<script>
import MixedGridFiltersSelected from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersSelected';
import { PhxIcon } from '@phx-styleguides/jlc';
import { pickBy } from 'lodash-es';

const reversoFilterId = 'wdi-typeofdial';
export default {
  components: {
    PhxIcon,
  },

  mixins: [MixedGridFiltersSelected],

  props: {
    customTags: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['removeFilter'],

  computed: {
    hasCustomTags() {
      return this.customTags.length > 0;
    },

    filteredActiveFilters() {
      return pickBy(this.activeFilters, (item, key) => key !== reversoFilterId);
    },
  },
};
</script>

<template>
  <ul v-if="hasFilters || hasCustomTags" class="products__active-filters" data-cy="mixed-grid-filters-selected">
    <template v-if="hasCustomTags">
      <li
        v-for="(tag, index) in customTags"
        :key="index"
        class="products__active-filters-item"
        data-cy="mixed-grid-filters-selected-choice"
      >
        <span class="tag tag--md tag--no-uppercase">
          {{ tag }}
        </span>
      </li>
    </template>

    <template v-for="(groupedFilters, filterId) in filteredActiveFilters" :key="filterId">
      <li
        v-if="isSellable(filterId)"
        class="products__active-filters-item"
        data-cy="mixed-grid-filters-selected-choice"
      >
        <button
          type="button"
          class="btn btn--default btn--xs btn--filter btn--rounded btn--even btn--outlined btn--icon"
          @click="$emit('removeFilter', filterId)"
        >
          <span class="btn__text">{{ $t('Products.filters.availableOnline') }}</span>
          <span class="btn__icon">
            <phx-icon icon="cross-10" class="icon--10" />
          </span>
        </button>
      </li>

      <li
        v-else-if="isRange(filterId)"
        class="products__active-filters-item"
        data-cy="mixed-grid-filters-selected-choice"
      >
        <button
          type="button"
          class="btn btn--default btn--xs btn--filter btn--rounded btn--even btn--outlined btn--icon"
          @click="$emit('removeFilter', filterId)"
        >
          <span class="btn__text">{{ getFilterById(filterId).label }}</span>
          <span class="btn__icon">
            <phx-icon icon="cross-10" class="icon--10" />
          </span>
        </button>
      </li>
      <template v-else>
        <li
          v-for="value in groupedFilters"
          :key="value"
          class="products__active-filters-item"
          data-cy="mixed-grid-filters-selected-choice"
        >
          <span v-if="isUnclearable(filterId)" class="tag tag--md tag--no-uppercase">
            {{ getFilterById(filterId).label }}: {{ getFilterItemFromIdAndValue(filters, filterId, value)?.label }}
          </span>

          <button
            v-else
            type="button"
            class="btn btn--default btn--xs btn--filter btn--rounded btn--even btn--outlined btn--icon"
            :class="{ 'btn--with-pill': isColor(filterId) }"
            @click="$emit('removeFilter', filterId, value)"
          >
            <span
              v-if="isColor(filterId)"
              class="btn__pill"
              :style="`--pill-bg: ${getFilterItemFromIdAndValue(filters, filterId, value).valueName}`"
            ></span>
            <span class="btn__text">{{ getFilterItemFromIdAndValue(filters, filterId, value).label }}</span>
            <span class="btn__icon">
              <phx-icon icon="cross-10" class="icon--10" />
            </span>
          </button>
        </li>
      </template>
    </template>
  </ul>
</template>
